export const downloadFile = (blob: Blob, filename?: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = filename ? filename : "";
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
};
